import React from 'react';
import { ArrowRight } from 'lucide-react';

const Button = ({
  children,
  onClick,
  withArrow = false,
  className = '',
  type = 'button',
  disabled = false
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        relative overflow-hidden
        bg-gradient-to-r from-custom-purple via-custom-blue to-custom-light-blue
        hover:from-custom-light-blue hover:via-custom-blue hover:to-custom-purple
        text-white font-semibold
        px-6 py-3 rounded-lg
        transition-all duration-300 
        transform hover:scale-[1.02]
        disabled:opacity-50 disabled:cursor-not-allowed
        flex items-center justify-center
        ${className}
      `}
    >
      <span className="relative z-10 flex items-center">
        {children}
        {withArrow && <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />}
      </span>
    </button>
  );
};

export default Button;